import {Box, Button, Stack} from '@mui/material';
import {get_currency} from 'common';
import {useEffect, useState} from 'react';
import {AdvancedRealTimeChart} from 'react-ts-tradingview-widgets';

type TradingViewInterval = '1' | '5' | '60' | '240' | '3' | '15' | '30' | '120' | '180' | 'D' | 'W';

interface IntervalOption {
	interval: TradingViewInterval;
	tag: string;
}

export default function TVChartBox(props: {exchange: string; ticker: string}) {
	const {exchange, ticker} = props;

	const intervals: IntervalOption[] = [
		{interval: '1', tag: '1m'},
		{interval: '5', tag: '5m'},
		{interval: '15', tag: '15m'},
		{interval: '60', tag: '1h'},
		{interval: '240', tag: '4h'},
		{interval: 'D', tag: '1D'},
	];

	const [cur_interval, set_cur_interval] = useState(intervals[0]);
	const currency = get_currency(exchange);
	const symbol = `${exchange}:${ticker}${currency}`;
	const [key, set_key] = useState<string>(`${symbol}-${cur_interval.interval}`);

	useEffect(() => {
		set_key(`${symbol}-${cur_interval.interval}`);
	}, [symbol, cur_interval.interval]);

	return (
		<Stack position="relative">
			<AdvancedRealTimeChart
				key={key}
				container_id="tradingview_chart"
				width="100%"
				height="300"
				symbol={symbol}
				interval={cur_interval.interval}
				timezone="Asia/Seoul"
				hide_top_toolbar={true}
				hide_side_toolbar={true}
				withdateranges={false}
				hide_legend={true}
				theme="dark"
				studies={['Volume@tv-basicstudies']}
			/>

			<Box id="duration-selector" display="flex" alignItems="center" justifyContent="space-between" width="100%" position="absolute" bottom="0" left="0" bgcolor="#030303">
				{intervals.map(interval => (
					<Button
						key={interval.interval}
						size="small"
						onClick={() => set_cur_interval(interval)}
						color={cur_interval.interval === interval.interval ? 'primary' : 'inherit'}
						variant={cur_interval.interval === interval.interval ? 'outlined' : 'text'}
						sx={{fontSize: '0.7rem', textTransform: 'none', flex: 1, minWidth: 0, px: 0.5, py: 0.25}}
					>
						{interval.tag}
					</Button>
				))}
			</Box>
		</Stack>
	);
}
